  (function () {
    if (window.__crVitrinaListo) return;
    window.__crVitrinaListo = true;

    var quieto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function armar(raiz) {
      if (!raiz || raiz.dataset.crVitArmado === '1') return;
      raiz.dataset.crVitArmado = '1';

      var pista = raiz.querySelector('[data-cr-vit-pista]');
      if (!pista) return;

      var reales = Array.prototype.slice.call(pista.querySelectorAll('[data-cr-vit-slide]'));
      var n = reales.length;
      if (n < 2) return;

      var puntos = raiz.querySelectorAll('[data-cr-vit-punto]');
      var segundos = parseInt(raiz.dataset.crVitSegundos, 10) || 5;
      var auto = raiz.dataset.crVitAuto === '1' && !quieto;

      /* ---- Bucle infinito ------------------------------------------------
         Se clona la última diapositiva al principio y la primera al final.
         Así avanzar desde la última es UN paso hacia adelante en vez de un
         rebobinado largo hasta el comienzo — que es lo que se atascaba,
         porque scroll-snap-stop: always frena el desplazamiento en cada
         punto de anclaje intermedio. Al aterrizar sobre un clon se salta sin
         animación a su gemela real: como son idénticas, no se nota.        */
      function clonar(orig) {
        var c = orig.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('data-cr-vit-clon', '1');
        c.removeAttribute('id');
        var conId = c.querySelectorAll('[id]');
        for (var i = 0; i < conId.length; i++) conId[i].removeAttribute('id');
        var focables = c.querySelectorAll('a, button, input, select, textarea');
        for (var j = 0; j < focables.length; j++) focables[j].setAttribute('tabindex', '-1');
        return c;
      }
      pista.insertBefore(clonar(reales[n - 1]), reales[0]);
      pista.appendChild(clonar(reales[0]));

      var slides = pista.querySelectorAll('[data-cr-vit-slide]'); // n + 2
      var fisico = 1;   // 0 = clon del final · 1..n = las reales · n+1 = clon del inicio
      var reloj = null;
      var reanudar = null;
      var finReposo = null;
      var visible = true;

      // Las posiciones se miden contra la primera diapositiva: así da igual
      // cuál sea el offsetParent y no le afecta el desplazamiento.
      function inicio(i) {
        return slides[i].offsetLeft - slides[0].offsetLeft;
      }

      function pintar() {
        var real = (fisico - 1 + n) % n;
        for (var p = 0; p < puntos.length; p++) {
          if (p === real) {
            puntos[p].setAttribute('aria-current', 'true');
          } else {
            puntos[p].removeAttribute('aria-current');
          }
        }
      }

      // Colocación instantánea. El estilo en línea gana sobre el
      // scroll-behavior: smooth que trae el CSS de la pista.
      function saltar(p) {
        var antes = pista.style.scrollBehavior;
        pista.style.scrollBehavior = 'auto';
        pista.scrollLeft = inicio(p);
        void pista.offsetWidth;
        pista.style.scrollBehavior = antes || '';
      }

      // Se llama cuando el movimiento ya se detuvo. Hace dos cosas:
      // 1. Si quedamos parados sobre un clon, salta a su gemela real.
      // 2. Red de seguridad: si el desplazamiento suave no llegó a destino,
      //    lo coloca a mano. Hace falta porque scroll-snap-stop: always
      //    aborta los desplazamientos animados por script en varios
      //    navegadores, y entonces los puntos avanzaban pero la imagen no.
      function asentar() {
        if (fisico === 0) fisico = n;
        else if (fisico === n + 1) fisico = 1;
        if (Math.abs(pista.scrollLeft - inicio(fisico)) > 2) saltar(fisico);
        pintar();
      }

      function alAsentarse() {
        if (finReposo) clearTimeout(finReposo);
        finReposo = setTimeout(function () {
          finReposo = null;
          asentar();
        }, 620);
      }

      function irA(p, suave) {
        if (!slides[p]) return;
        fisico = p;
        pintar();
        if (suave === false || quieto) {
          saltar(p);
        } else {
          pista.scrollTo({ left: inicio(p), behavior: 'smooth' });
        }
        alAsentarse();
      }

      function siguiente() { irA(fisico + 1); }
      function anterior() { irA(fisico - 1); }

      function arrancar() {
        if (!auto || reloj) return;
        reloj = setInterval(function () {
          if (!visible || document.hidden) return;
          siguiente();
        }, segundos * 1000);
      }

      function frenar(msPausa) {
        if (reloj) { clearInterval(reloj); reloj = null; }
        if (reanudar) { clearTimeout(reanudar); reanudar = null; }
        if (auto && msPausa) {
          reanudar = setTimeout(arrancar, msPausa);
        }
      }

      // Posición actual según dónde quedó el desplazamiento
      var pendiente = false;
      pista.addEventListener('scroll', function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () {
          pendiente = false;
          var centro = pista.scrollLeft + pista.clientWidth / 2;
          for (var i = 0; i < slides.length; i++) {
            if (centro >= inicio(i) && centro < inicio(i) + slides[i].offsetWidth) {
              if (i !== fisico) { fisico = i; pintar(); }
              break;
            }
          }
          alAsentarse();
        });
      }, { passive: true });

      // El dedo o el mouse mandan: se pausa y se reanuda a los 10 segundos.
      // La rueda solo cuenta si el gesto es horizontal — si no, desplazar la
      // página con el mouse encima del carrusel lo dejaba detenido.
      ['pointerdown', 'touchstart'].forEach(function (evt) {
        pista.addEventListener(evt, function () { frenar(10000); }, { passive: true });
      });
      pista.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) frenar(10000);
      }, { passive: true });

      raiz.addEventListener('mouseenter', function () { frenar(0); });
      raiz.addEventListener('mouseleave', function () { arrancar(); });
      raiz.addEventListener('focusin', function () { frenar(0); });
      raiz.addEventListener('focusout', function () { arrancar(); });

      for (var p = 0; p < puntos.length; p++) {
        (function (idx) {
          puntos[idx].addEventListener('click', function () {
            frenar(10000);
            irA(idx + 1);
          });
        })(p);
      }

      var prev = raiz.querySelector('[data-cr-vit-prev]');
      var next = raiz.querySelector('[data-cr-vit-next]');
      if (prev) prev.addEventListener('click', function () { frenar(10000); anterior(); });
      if (next) next.addEventListener('click', function () { frenar(10000); siguiente(); });

      pista.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { frenar(10000); siguiente(); }
        if (e.key === 'ArrowLeft') { frenar(10000); anterior(); }
      });

      // Al cambiar el tamaño de la ventana las posiciones cambian
      var reajuste = null;
      window.addEventListener('resize', function () {
        if (reajuste) clearTimeout(reajuste);
        reajuste = setTimeout(function () { irA(fisico, false); }, 150);
      }, { passive: true });

      // Solo gira mientras se está viendo
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entradas) {
          visible = entradas[0].isIntersecting;
        }, { threshold: 0.35 }).observe(raiz);
      }

      // Arranca parada sobre la primera real, no sobre el clon
      requestAnimationFrame(function () { irA(1, false); });
      arrancar();

      // En el editor de temas, elegir un bloque lleva a su diapositiva
      document.addEventListener('shopify:block:select', function (e) {
        var slide = e.target.closest ? e.target.closest('[data-cr-vit-slide]') : null;
        if (!slide || !raiz.contains(slide) || slide.hasAttribute('data-cr-vit-clon')) return;
        frenar(0);
        for (var i = 0; i < reales.length; i++) {
          if (reales[i] === slide) { irA(i + 1); break; }
        }
      });
    }

    function armarTodo() {
      var todas = document.querySelectorAll('[data-cr-vit]');
      for (var i = 0; i < todas.length; i++) armar(todas[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', armarTodo);
    } else {
      armarTodo();
    }
    document.addEventListener('shopify:section:load', armarTodo);
  })();
